/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getBoostStyles = ({ styleOverrides }) => () => {
  return {
    boostDiscover: _.extend({
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      fontSize: 16,
      color: 'black',
      borderBottom: '1px solid #C8C8C8',
      paddingLeft: 10,
    }, styleOverrides.boostDiscover),
    boostWindows: _.extend({
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'space-between',
      top: 20,
      left: '50%',
      color: 'white',
      transform: 'translate(-50%)',
      '& .welcome': {
        marginBottom: 10,
      },
      '& .time': {
        fontSize: 40,
      },
    }, styleOverrides.boostWindows),
  };
};
